import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { OptionPmsContainer } from "@/components/features/option-pms/container";

import { useConfirmParams } from "./hooks";

export const ManagementActivitiesOptionsPage = () => {
	const result = useConfirmParams();
	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="オプションの管理" url={generatePath(PATHS.HOTEL.MANAGEMENT.ACTIVITIES.OPTIONS, { hotelID })}>
			<OptionPmsContainer hotelID={hotelID} />
		</PageMeta>
	);
};
